import React, {PropTypes} from 'react';
import classNames from 'classnames';

const VoteControl = ({votesType, value, onVoteUpClick, onVoteDownClick, isDisabled, voteStatus}) => {
  const isPositiveVoteValue = value >= 0;
  const isNegativeVoteValue = value < 0;
  const VoteControlCssClass = classNames({
    'vote-control': true,
    'vote-control--positive-votes': isPositiveVoteValue,
    'vote-control--negative-votes': isNegativeVoteValue,
  });
  const voteValueCssClass = classNames({
    'vote-control__value': true,
    'vote-control__value--positive': isPositiveVoteValue,
    'vote-control__value--negative': isNegativeVoteValue,
  });

  const voteUpCssClass = classNames({
    [`t-${votesType}-vote-up-btn`]: votesType,
    'vote-control__button': true,
    'vote-control__button--vote-up': true,
    'vote-control__button--active-up': voteStatus === 1,
    'vote-control__button--is-disabled': isDisabled,
  });

  const voteDownCssClass = classNames({
    [`t-${votesType}-vote-down-btn`]: votesType,
    'vote-control__button': true,
    'vote-control__button--vote-down': true,
    'vote-control__button--active-down': voteStatus === -1,
    'vote-control__button--is-disabled': isDisabled,
  });
  return (
    <div className={VoteControlCssClass}>
      <div className="vote-control__button-container">
        <div className={voteUpCssClass} onClick={onVoteUpClick} />
        <div className={voteDownCssClass} onClick={onVoteDownClick} />
      </div>
      <div className={voteValueCssClass}>
        <span className="hidden">{votesType}</span>
        {value}
      </div>
    </div>
  );
};

VoteControl.propTypes = {
  votesType: PropTypes.string.isRequired,
  onVoteUpClick: PropTypes.func,
  onVoteDownClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  voteStatus: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default VoteControl;
